module.exports = __webpack_public_path__ + "media/media/product-card/vlsat_pro_empty-211b9b9ecb7723e988d3757384206206.jpg";